import type { Router, RouteRecordRaw } from 'vue-router'
import { PageName } from 'shared/lib/types/app/pages'

export const moduleRoute: RouteRecordRaw = {
  path: '',
  name: PageName.LOGIN_PAGE,
  component: () => import('modules/login/pages/LoginPage.vue'),
  children: [],
}

export default (router: Router) => {
  router.addRoute(PageName.LOGIN_LAYOUT, moduleRoute)
}
